import type { ChatAuthor, ChatTag } from './core'

type Listener = (tag: ChatTag, people: ChatAuthor[]) => void

const listeners = new Set<Listener>()

/**
 * Joining or leaving a booking posts no Message, so every stream on screen hears of it
 * here and shows who's on the booking now on its cards of it.
 */
export const onBookingMembershipChange = (listener: Listener): (() => void) => {
	listeners.add(listener)
	return () => {
		listeners.delete(listener)
	}
}

/** Called once I've joined or left a booking, with who's on it now. */
export const announceBookingMembershipChange = (tag: ChatTag, people: ChatAuthor[]): void => {
	listeners.forEach(listener => listener(tag, people))
}
